import { BookLink, Chapter, Reveal } from "./booking";

const REASONS = [
  { title: "Expert Barbers", desc: "Skilled barbers focused on precision and detail." },
  { title: "Modern & Clean Environment", desc: "A clean, comfortable, modern barbershop experience." },
  { title: "Affordable Pricing", desc: "Premium grooming without an unnecessarily expensive experience." },
  { title: "Walk-Ins & Appointments", desc: "Total flexibility — walk in, or lock in your chair online." },
  { title: "Quality Grooming", desc: "From fades and tapers to beard work and shaves." },
];

export default function WhyFaded() {
  return (
    <section id="why" data-testid="why-faded-section" className="px-5 lg:px-12 py-20 lg:py-32 border-t border-border">
      <Chapter index="03" title="Why Faded" />
      <Reveal>
        <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mb-14">
          Why Springfield
          <br />
          chooses <span className="text-primary">Faded.</span>
        </h2>
      </Reveal>
      <div className="border-t border-border">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.05}>
            <div className="group grid sm:grid-cols-12 gap-2 sm:gap-6 items-baseline py-7 border-b border-border transition-colors duration-300 hover:bg-card px-2 sm:px-4 -mx-2 sm:-mx-4">
              <span className="sm:col-span-2 font-mono text-sm text-primary tracking-[0.25em]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="sm:col-span-5 font-display uppercase text-3xl sm:text-4xl leading-none transition-transform duration-300 group-hover:translate-x-2">
                {r.title}
              </h3>
              <p className="sm:col-span-5 text-sm sm:text-base text-muted-foreground font-light leading-relaxed">
                {r.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-12">
        <BookLink testid="why-book-button" className="btn-primary">
          Book an Appointment
        </BookLink>
      </Reveal>
    </section>
  );
}
